import { LDUserCustom } from '../hooks/useLaunchDarklyUser';

/**
 * @deprecated This enum is deprecated and should not be used in new code.
 * Use LaunchDarklyClientEventEnum from application-types instead.
 */
export enum LaunchDarklyClientEventEnum {
  change = 'change',
  ready = 'ready',
}

type LDFlagValue = any;

/**
 * @deprecated This type is deprecated and should not be used in new code.
 * Use LDFlagSet from application-types instead.
 */
export type LDFlagSet = {
  [key: string]: LDFlagValue;
};

/**
 * @deprecated This type is deprecated and should not be used in new code.
 * Use LaunchDarklyEvents from application-types instead.
 */
export type LaunchDarklyEvents =
  | `${LaunchDarklyClientEventEnum}`
  | LaunchDarklyClientEventEnum;

export type LaunchDarklyEventCallback<T extends LaunchDarklyEvents = any> = (
  payload: T extends 'ready' ? LDFlagSet | null : LDFlagSet
) => void;

type ILaunchDarklyClient = {
  on: <T extends LaunchDarklyEvents>(
    event: T,
    cb: LaunchDarklyEventCallback<T>
  ) => void;
  off: <T extends LaunchDarklyEvents>(
    event: T,
    cb: LaunchDarklyEventCallback<T>
  ) => void;
  setUser: (key: string, custom?: Partial<LDUserCustom>) => void;
  unsetUser: () => void;
  setAttribute: (field: Partial<LDUserCustom>) => void;
};

/**
 * @deprecated This export is deprecated and should not be used in new code.
 * Use the equivalent from application-types instead.
 */
export default ILaunchDarklyClient;
